<!-- Итог и общие действия черновика исходных данных перед созданием новой версии. -->
<template>
  <footer class="plan-norm-actions">
    <span class="plan-norm-actions__preview">
      <span>{{ resultName }} после пересчёта</span>
      <strong>Рассчитается при сохранении новой версии</strong>
    </span>
    <base-button compact variant="ghost" :disabled="!changedCount" @click="$emit('reset')">
      Сбросить к калькулятору
    </base-button>
    <PlanCalculationActionButton
      class="plan-norm-actions__recalculate"
      size="regular"
      :disabled="invalid || isCalculating"
      @click="$emit('recalculate')"
    >
      Пересчитать → v{{ nextVersion }}
    </PlanCalculationActionButton>
  </footer>
</template>

<script>
import PlanCalculationActionButton from "@/components/Order/PlanCalculation/Buttons/Action.vue";

export default {
  name: "OrderPlanCalculationNormActions",

  components: { PlanCalculationActionButton },

  props: {
    nextVersion: { type: Number, required: true },
    invalid: { type: Boolean, default: false },
    isCalculating: { type: Boolean, default: false },
    changedCount: { type: Number, default: 0 },
    resultName: { type: String, default: "Результат" },
  },

  emits: ["reset", "recalculate"],
};
</script>

<style scoped>
.plan-norm-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-top: 1px solid #e0e7ff;
  background: #f5f7ff;
  color: #4b5068;
  font-size: 13px;
}

.plan-norm-actions > :nth-last-child(2) {
  margin-left: auto;
}

.plan-norm-actions__preview {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.plan-norm-actions__preview > strong {
  color: #5b6070;
  font-size: 12px;
  font-weight: 400;
}

@media (max-width: 768px) {
  .plan-norm-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .plan-norm-actions > :nth-last-child(2) {
    margin-left: 0;
  }
}
</style>
